"use client"

import React from "react"

export function SummaryCard({ title, value, sub }) {
  return (
    <div className="border rounded-lg p-3 bg-white shadow-sm
                    border-gray-200
                    dark:bg-gray-800 dark:border-gray-700">
      <div className="text-sm text-gray-600 dark:text-gray-300">
        {title}
      </div>
      <div className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
        {value}
      </div>
      {sub ? (
        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          {sub}
        </div>
      ) : null}
    </div>
  )
}
